import React, { useState, useEffect } from 'react';
import { getPackageList, SocialTrigger } from '../../../../../Api/apiUtils';
import { ChevronDown } from 'react-feather';
import { Badge, Button, DescriptionList, EmptyState, Loader, Table, TextInput } from '../../../../../ui';
import { Callout, Dialog } from '../ui-pending';
import FindTeacher from '../findTeacher';
import { FaWhatsapp, FaEnvelope, FaCopy } from 'react-icons/fa';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CustomPayment from './custom-payment';
import { formatDate } from '../../../../../utils/formatDate';
import './payment-panels.scss';

const getPackageCourseName = (packageData: any) => {
  const courseName = packageData?.courseData?.[0]?.courseName || "";
  const instrumentCombo = packageData?.instrumentCombo ?? packageData?.instrument;
  if (instrumentCombo?.enabled) {
    return `${courseName} - Combo`;
  }
  return courseName;
};

const PaymentTable: React.FC<any> = ({ studentId, profileData, setTriggerPackageCallback }) => {
  console.log (profileData,"profileData")
  const [packageList, setPackageList] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [expandedId, setExpandedId] = useState<string | null>(null);
  const [modal, setModal] = useState<boolean>(false);
  const [isSocialOpen, setIsSocialOpen] = useState<boolean>(false);
  const [paymentModal, setPaymentModal] = useState<boolean>(false);
  const [shareDropdownId, setShareDropdownId] = useState<string | null>(null);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedPackage, setSelectedPackage] = useState<any>(null);
  const [messageType, setMessageType] = useState<"whatsApp" | "email" | "">("")
  const fetchData = async () => {
    try {
      const response = await getPackageList(studentId);
      if (response.length) {
        let filterArray = response.filter((item: any) => item.academicVersion);
        const sortedData = filterArray.sort((a: any, b: any) => 
          new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()
        );
        
        // Use Set to track unique courseIds efficiently
        const uniqueCourses = new Set<string>();
        
        const filteredData = sortedData.filter((e: any) => {
          if (e.orderId) {
            // If orderId exists, always include it
            return true;
          }
        
          if (!uniqueCourses.has(e.courseId)) {
            uniqueCourses.add(e.courseId);
            return true;
          }
        
          return false;
        });
        
        console.log(filteredData);
        setPackageList(filteredData);
      }else{
        setPackageList([]);
      }
      
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to fetch data. Please try again.");
      setLoading(false);
    }
  };
  const paymentCallBackFromParent = () => {
    fetchData();
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (setTriggerPackageCallback) {
      setTriggerPackageCallback(() => paymentCallBackFromParent);
    }
  }, [setTriggerPackageCallback]);

  const toggleModal = () => setModal(!modal);
  const socialToggle = () => setIsSocialOpen(!isSocialOpen);;
  
  const openModal = (type: "whatsApp" | "email",  packageData: any) => {
    setSelectedPackage(packageData); 
    setMessageType(type);
    socialToggle();
  };

  const togglePaymentModal = (packageData:any) => {

    if(packageData){
      setSelectedPackage(packageData);
    }
    setPaymentModal(!paymentModal)
  };

  if (loading) return <Loader label="Loading packages…" />;
  if (error) return <Callout tone="danger">{error}</Callout>;
  if (!packageList) return <EmptyState title="No packages" description="No package data is available for this student." />;

  const handleChange = (
    planIndex: number,
    classIndex: number,
    field: any,
    value: string | number,
    package_id: string
  ) => {
    const sanitizedValue = typeof value === "string" ? value.replace(/^0+/, '') : value;
    const updatedPackages = packageList;
    if (field == "ClassCount") {
      updatedPackages.find((e: any) => e.package_id == package_id).planList[planIndex].classList[classIndex]["classCount"] = Number(sanitizedValue);
    }
    setPackageList(updatedPackages);
  };

  const toggleExpanded = (packageId: string) => {
    setExpandedId(expandedId === packageId ? null : packageId);
  };

  const toggleShareDropdown = (packageId: string, packageData:any) => {
    setShareDropdownId(shareDropdownId === packageId ? null : packageId);
    if(packageData){
      setSelectedPackage(packageData);
    }else{
      setSelectedPackage(null);
    }
  };


  const handleCopyLink = (payLink: string) => {
    const profileData = JSON.parse(localStorage.getItem("profileData") || "{}");
    const userName = profileData.firstName;
    const cleanedUserName = userName.trim().replace(/\s+/g, '_');
    const encodedUserName = encodeURIComponent(cleanedUserName);
    let finalLink = "";
  
    if (payLink.includes("?")) {
      finalLink = `${payLink}&utm_source=admin&utm_campaign=${encodedUserName}`;
    } else {
      finalLink = `${payLink}?utm_source=admin&utm_campaign=${encodedUserName}`;
    }
  
    navigator.clipboard
      .writeText(finalLink)
      .then(() => {
        toast.success("Copied successfully!", { position: "top-right" });
      })
      .catch(() => {
        toast.error("Failed to copy!", { position: "top-right" });
      });
  };
  
  const handleSendLink = async () => {
    const profileData = JSON.parse(localStorage.getItem("profileData") || "{}");
    const userName = profileData.firstName || ''; // Fallback to empty string if undefined
    
    try {
      setLoading(true);
      console.log("selectedPackage", selectedPackage);

      // Clean and encode the username
      const cleanedUserName = userName.trim().replace(/\s+/g, '_');
      const encodedUserName = encodeURIComponent(cleanedUserName);

      const msg = {
        emailId: selectedPackage.email,
        studentName: selectedPackage.name,
        messageType,
        mobileNumber: selectedPackage.countryCode + selectedPackage.contact,
        paymentLink: `${selectedPackage.packageLink}?utm_source=admin&utm_campaign=${encodedUserName}`,
      };

      await SocialTrigger(msg);
      toast.success("Link shared successfully!");
    } catch (error) {
      console.error("Error sending link:", error);
      toast.error("Failed to send link!");
    } finally {
      setLoading(false);
      socialToggle();
    }
  };
  const handleShareWhatsApp = (link: string) => {
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(link)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleShareEmail = (link: string) => {
    const emailUrl = `mailto:?subject=Check this out&body=${encodeURIComponent(link)}`;
    window.location.href = emailUrl;
  };

  const calculateDifference = (packageDetails:any) => {
    const currentDate = new Date();
    const targetDate = new Date(packageDetails?.classDateTime);
    targetDate.setHours(targetDate.getHours() + 1); // Add 1 hour

    const diffInMilliseconds = targetDate.getTime() - currentDate.getTime();
    return diffInMilliseconds >= 0 ? diffInMilliseconds : 0;
  };

  return (
    <div className="ds-stack payment-packages">

      <Dialog
        size="xl"
        isOpen={modal}
        onClose={toggleModal}
        title="Find teacher"
        actions={
          <Button variant="secondary" onClick={toggleModal}>
            Close
          </Button>
        }
      >
        <FindTeacher  profileData = {""} studentId={studentId} />
      </Dialog>
      <Dialog size="xl" isOpen={paymentModal} onClose={() => {togglePaymentModal(null)}} title="Edit package">
        <CustomPayment saveCallBack={() => {fetchData(); setPaymentModal(false)}} profileData={profileData} selectedPackage={selectedPackage} studentId={studentId} />
      </Dialog>
      {packageList.length === 0 && (
        <EmptyState title="No packages yet" description="Use Create Package to build one for this student." />
      )}
      {packageList.map((data: any) => (
        <div
          // every split part shares the package id, so key on package_id which
          // carries createdOn and is therefore unique per row
          key={data.package_id || data.id}
          className={`payment-package${data.split_group_id ? " payment-package--split" : ""}`}
        >
          <div className="payment-package__row">

            <div className="payment-package__summary">
              {data.split_group_id ? (
                <div>
                  <Badge tone="primary">
                    Split Payment · Part {data.split_part} of {data.split_parts_total}
                  </Badge>
                </div>
              ) : null}
              <DescriptionList
                items={[
                  { label: "Course Name", value: getPackageCourseName(data) },
                  { label: "Teacher Name", value: data.teacherName },
                  { label: "Created On", value: formatDate(data.createdOn, "dateTime") },
                  ...(data.orderId ? [{ label: "Payment Transaction Id", value: data.orderId }] : []),
                  ...(data?.freeCourse
                    ? [{ label: "Free Course", value: `${data?.freeCourse.courseName} - ${data?.freeCourse.classesToPurchase} classes` }]
                    : []),
                ]}
              />
            </div>
            <div className="payment-package__actions">
              {/* <div>    Expiry Date:  <DatePicker
                selected={selectedDate}
                onChange={(date: Date) => setSelectedDate(date)}
                dateFormat="dd/MM/yyyy"
                placeholderText="Select Date"
                className="form-control"
                wrapperClassName="date-picker"
              /></div>    */}
              {/* <Button onClick={toggleModal}>
                Change Teacher
              </Button> */}
              <div className="payment-package__share">
                <Button
                  variant="secondary"
                  size="sm"
                  disabled={!!data.orderId}
                  aria-haspopup="menu"
                  aria-expanded={shareDropdownId === data.package_id}
                  onClick={() => toggleShareDropdown(data.package_id, data)}
                >
                  Share Link
                </Button>
                {shareDropdownId === data.package_id && (
                  <div className="payment-package__menu" role="menu">
                    <Button variant="ghost" size="sm" block role="menuitem" icon={<FaCopy aria-hidden />} onClick={() => handleCopyLink(data.packageLink )}>
                      Copy
                    </Button>
                    <Button variant="ghost" size="sm" block role="menuitem" icon={<FaWhatsapp aria-hidden />} onClick={() => openModal("whatsApp", data)}>
                      WhatsApp
                    </Button>
                    <Button variant="ghost" size="sm" block role="menuitem" icon={<FaEnvelope aria-hidden />} onClick={() => openModal("email", data)}>
                      Email
                    </Button>
                  </div>
                )}
              </div>

              <Dialog
                isOpen={isSocialOpen}
                onClose={socialToggle}
                title="Share this link?"
                size="sm"
                actions={
                  <>
                    <Button variant="secondary" onClick={socialToggle} disabled={loading}>
                      Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSendLink} loading={loading}>
                      {loading ? "Sending..." : "Share Link"}
                    </Button>
                  </>
                }
              >
                Are you sure you want to share this link?
              </Dialog>
              <Button variant="secondary" size="sm" disabled={!!data.orderId} onClick={() => {togglePaymentModal(data)}}>
                {data?.customPlan ? "Edit Package":"Customize Package"}
              </Button>
              <Button
                variant="ghost"
                size="sm"
                aria-expanded={expandedId === data.package_id}
                aria-label={expandedId === data.package_id ? "Hide plan details" : "Show plan details"}
                className={`payment-package__toggle${expandedId === data.package_id ? " payment-package__toggle--open" : ""}`}
                icon={<ChevronDown size={18} aria-hidden />}
                onClick={() => toggleExpanded(data.package_id)}
              />
            </div>
          </div>
          {expandedId === data.package_id && (<>
            {!data?.customPlan && (
              <Table caption="Plan details">
                <thead>
                  <tr>
                    <th>Plan</th>
                    <th className="ds-num">Class Count</th>
                    <th className="ds-num">Flash Discount (%)</th>
                    <th className="ds-num">Special Discount(%)</th>
                    <th className="ds-num">Price Detail ({data.courseData[0].currency})</th>
                  </tr>
                </thead>
                <tbody>
                  {data.planList.map((planData: any, planIndex: any) => (
                    planData.classList.map((classDetail: any, subCountIndex: any) => (
                      <tr key={`${planIndex}-${subCountIndex}`}>
                        {subCountIndex === 0 && (
                          <td rowSpan={planData.classList.length}>
                            {planData.plan}
                          </td>
                        )}
                        <td className="ds-num">
                          <TextInput
                            size="sm"
                            numeric
                            disabled
                            aria-label="Class count"
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={classDetail.classCount}
                            onChange={(e) => handleChange(planIndex, subCountIndex, 'ClassCount', Number(e.target.value), data.package_id)}
                          />
                        </td>
                        <td className="ds-num">
                          <TextInput
                            size="sm"
                            numeric
                            disabled
                            aria-label="Flash discount (%)"
                            type="number"
                            value={classDetail.flashDiscountPercentage}
                            onChange={(e) => handleChange(planIndex, subCountIndex, 'FlashDiscount', Number(e.target.value), data.package_id)}
                          />
                        </td>
                        <td className="ds-num">
                          <TextInput
                            size="sm"
                            numeric
                            disabled
                            aria-label="Special discount (%)"
                            type="number"
                            value={classDetail.specialDiscountPercentage}
                            onChange={(e) => handleChange(planIndex, subCountIndex, 'specialDiscountPercentage', Number(e.target.value), data.package_id)}
                          />
                        </td>
                        <td className="ds-num">
                          {classDetail.discountedTotal}
                        </td>
                      </tr>
                    ))
                  ))}
                </tbody>
              </Table>
            )}
            {data?.customPlan && (
              <Table caption="Custom plan details">
                <thead>
                  <tr>
                    <th>Class Count</th>
                    <th className="ds-num">Special Discount (%)</th>
                    <th className="ds-num">Additional Discount (%)</th>
                    <th className="ds-num">Flash Discount (%)</th>
                    <th className="ds-num">Price ({data.courseData[0].currency})</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div className="payment-package__levels">
                        {data.customPlan.levelList.map((level: any, index: number) => (
                          <div key={index} className="payment-package__level">
                            <span>{level.level}</span>
                            <TextInput
                              size="sm"
                              numeric
                              aria-label={`Class count for ${level.level}`}
                              type="text"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              value={level.classCount}
                            />
                          </div>
                        ))}
                      </div>
                    </td>
                    <td className="ds-num">
                      <TextInput
                        size="sm"
                        numeric
                        disabled
                        aria-label="Special discount (%)"
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={data.customPlan.specialDiscountPercentage}
                      />
                    </td>
                    <td className="ds-num">
                      <TextInput
                        size="sm"
                        numeric
                        disabled
                        aria-label="Additional discount (%)"
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={data.customPlan.additionalDiscountPercentage}
                      />
                    </td>
                    <td className="ds-num">
                      <TextInput
                        size="sm"
                        numeric
                        disabled
                        aria-label="Flash discount (%)"
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={data.customPlan.flashDiscountPercentage}
                      />
                    </td>
                    {/* <td>
                      <TextInput
                        disabled
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={data.customPlan.discountPercentage}
                      />
                    </td> */}
                    <td className="ds-num">
                      <span className="ds-strong">{data.customPlan.total - ((((+((data.customPlan.classDateTime &&  calculateDifference(data.customPlan)) ? data.customPlan.flashDiscountPercentage : 0) + +data.customPlan.specialDiscountPercentage + +data.customPlan.additionalDiscountPercentage) / 100) * data.customPlan.total) + data.customPlan.walletAmount).toFixed(2)}</span>
                    </td>
                  </tr>
                </tbody>
              </Table>
            )}</>
          )}
        </div>
      ))}
    </div>
  );
};

export default PaymentTable;